import { createContext, useContext, useEffect, useState } from "react";
import { LANGUAGES, T, CATEGORY_LABELS } from "../i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    const meta = LANGUAGES.find((l) => l.code === lang);
    document.documentElement.dir = meta?.dir || "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => (T[lang] && T[lang][key]) || T.en[key] || key;
  const catLabel = (cat) => (CATEGORY_LABELS[lang] && CATEGORY_LABELS[lang][cat]) || CATEGORY_LABELS.en[cat] || cat;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, catLabel, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
